import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './StoreLocationTextCard.module.css';

/**
 * Shown when the storefront has no lat/lng for the map.
 * Either the resolved country name from profile, or a placeholder when country is missing.
 */
const StoreLocationTextCard = ({ countryLabel }) => {
  const body =
    countryLabel && String(countryLabel).trim() ? (
      countryLabel.trim()
    ) : (
      <FormattedMessage
        id="StoreProfilePage.Sidebar.locationPlaceholder"
        defaultMessage="Your location will appear here."
      />
    );

  return (
    <div className={css.root}>
      <h3 className={css.title}>
        <FormattedMessage
          id="StoreProfilePage.Sidebar.storeLocation"
          defaultMessage="Store Location"
        />
      </h3>
      <p className={css.areaText}>{body}</p>
    </div>
  );
};

StoreLocationTextCard.propTypes = {
  countryLabel: PropTypes.string,
};

export default StoreLocationTextCard;
